<template><div class="content">
  <QuizHeader/>
  <div style="height: 200px;" :style="{background: 'var(--bg-color)'}"></div>
  <div class="" style="margin-right: 15px; margin-left: 15px; margin-top: -125px">
    <div class="past-history-section common-section height-90">
      <div class="past-history-title text-center">
        <span>Leaderboard</span>
      <!-- <span>{{title}}</span>-->
      </div>

      <!-- Winner Section Start -->
      <div class="winner-section text-center border-top" v-if="top_winners && top_winners.length >= 3">
        <div class="title" style="margin-top: 10px;">
          <span>Winners</span>
        </div>

        <div class="row align-items-center">
          <div class="col-3">
            <div class="winner-block">
              <img src="@/assets/rank-2.svg" alt="rank-2" class="img-fluid">
              <p>{{top_winners[1].user_name}}</p>
            </div>
          </div>
          <div class="col-3">
            <div class="winner-block first-rank">
              <img src="@/assets/rank-1.svg" alt="rank-1" class="img-fluid">
              <p>{{top_winners[0].user_name}}</p>
            </div>
          </div>
          <div class="col-3">
            <div class="winner-block">
              <img src="@/assets/rank-3.svg" alt="rank-3" class="img-fluid">
              <p>{{top_winners[2].user_name}}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- Winner Section End -->

      <!-- History Table Start -->
      <div class="history-table border-top">
        <div class="table-responsive">
          <table class="table table-borderless">
            <thead>
            <tr>
              <th>Rank</th>
              <th>User</th>
              <th>Score</th>
              <th>{{currency_label}}</th>
            </tr>
            </thead>
            <tbody>
            <tr class="your-rank">
              <td>{{user_data.rank}}</td>
              <td class="name"><span>{{user_data.user_name}}</span></td>
              <td>{{user_data.score}}</td>
              <td>{{user_data.prize}}</td>
            </tr>
          </tbody>
          <tbody v-for="(item, index) in leaderboard">
            <tr>
              <td>{{item.rank}}</td>
              <td class="name"><span>{{item.user_name}}</span></td>
              <td>{{item.score}}</td>
              <td>{{item.prize}}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- History Table End -->
    </div>
  </div>
</div>
  <!-- content end -->
</template>

<script>
// import Tasks from '../components/Tasks'
import QuizHeader from '@/components/quiz-header'
import axios from "axios"
export default {
  name: 'PastHistory',
  components: {
    QuizHeader
  },
  // props: {
  //   id: Number,
  //   title: String
  // },
  data: () => ({
    id: null,
    title: null,
    top_winners: [],
    leaderboard: [],
    user_data: "",
    currency_label: ""
  }),
  computed: {},
  methods: {
    fetchLeaderboard() {
      var self = this;
      var url = self.$store.getters.flyyDomain + '/leaderboard/'+self.id;
      var headers = self.$store.getters.headers;
      axios.get(url, {
        headers: headers,
      }).then((resp) => {
        if(resp.status == 200) {
          var data = resp.data;
          // console.log(data)
          self.leaderboard = data.leaderboard;
          self.user_data = data.user_data;
          self.currency_label = data.currency_label;

          data.leaderboard.forEach((l,i)=>{
            if(i<=2){
              self.top_winners.push(l);
            }
          })
          //self.top_winners = data.leaderboard[0, 3]
        } else {
          console.log("Error fetching the Quiz list");
        }
      })
    }
  },
  created() {
    // this.$emit('handleHideFooter');
    this.id = this.$route.params.id
    this.title = this.$route.params.title
    //this.$store.state.quizDetailsTitle = "Leaderboard"
    this.fetchLeaderboard();
  },
  mounted() {
    this.$store.state.showQuizHistoryMenu = false;
  }
}
</script>

<style scoped>
  @import '../assets/quiz-styles/quiz-styles.css';
  @import '../assets/quiz-styles/bootstrap.css';
  @import '../assets/fonts/quiz-fonts/fonts.css';
</style>



// WEBPACK FOOTER //
// src/screens/leadboard.vue